import { html, ref } from "@microsoft/fast-element";
import { TeachingBubble } from "./teaching-bubble.js";
export function teachingBubbleTemplate() {
    return html `
    <template ?hidden="${(x) => !x.open}">
      <div class="image">
        <slot name="image"></slot>
      </div>
      <div class="content">
        <div class="close"><slot name="close"></slot></div>
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        <slot></slot>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
      <div id="arrow" class="arrow" ${ref("arrowEl")}></div>
    </template>
  `;
}
export const template = teachingBubbleTemplate();
//# sourceMappingURL=teaching-bubble.template.js.map